import React, { Component } from 'react';
import { Card, CardTitle, CardText } from 'react-mdl';

class ProjectCards extends Component {
    render() {
        const {
            title,
            summary,
            businessContext,
            industry,
            role,
            impact,
            technologies,
        } = this.props;

        return (
            <Card shadow={2} className="project-card">
                <CardTitle className="project-card-title">{title}</CardTitle>
                <CardText className="project-card-body">
                    <p className="project-summary">{summary}</p>

                    <div className="project-meta">
                        <span className="project-badge">{industry}</span>
                        <span className="project-role">{role}</span>
                    </div>

                    <div className="project-section">
                        <h4 className="project-section-label">Business context</h4>
                        <p>{businessContext}</p>
                    </div>

                    <div className="project-section">
                        <h4 className="project-section-label">Outcome & impact</h4>
                        <p>{impact}</p>
                    </div>

                    <div className="project-section">
                        <h4 className="project-section-label">Technologies & domains</h4>
                        <ul className="project-tags">
                            {technologies.map((item) => (
                                <li key={item} className="project-tag">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </CardText>
            </Card>
        );
    }
}

export default ProjectCards;
